import { render, staticRenderFns } from "./ModalBatch.vue?vue&type=template&id=a72c51a8&scoped=true"
import script from "./ModalBatch.vue?vue&type=script&lang=js"
export * from "./ModalBatch.vue?vue&type=script&lang=js"
import style0 from "./ModalBatch.vue?vue&type=style&index=0&id=a72c51a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a72c51a8",
  null
  
)

export default component.exports